import { ApiContext } from '../../types'
import getCurrentBearerToken from '../authentication/getCurrentBearerToken'

import { IQuery } from '@/api_client/interfaces/Query'
import { deserializePayout } from '@/api_client/api/serializers/payout'

export default async function getPayouts(
  { client, config }: ApiContext,
  params: IQuery = {},
): Promise<any> {
  try {
    const token = await getCurrentBearerToken({
      client,
      config,
    })

    if (
      params.filter &&
      params.filter.state_eq &&
      params.filter.state_eq.toString().length > 0 &&
      params.filter.state_eq.toString()[0] == '~'
    ) {
      params.filter.state_not_in = ['paid']
      params.filter.state_eq = null
    }

    const response = await client.payouts.list(
      { bearerToken: token },
      {
        ...params,
        per_page: params.per_page || 10,
        sort: '-id',
        include: 'user',
      },
    )
    if (response.isSuccess()) {
      const payload = response.success()
      console.log(payload)
      const data = payload.data.map((order) =>
        deserializePayout(order, payload.included, config),
      )
      return { ...payload, data }
    } else {
      throw response.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
